<template>
  <div>
    <Header></Header>
    <Common></Common>
  </div>
</template>
<script>
import Header from "./header.vue";
import Common from "./common.vue";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Common,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
</style>